import { useEffect, useState } from "react";
import { Loader2, ShieldCheck, FileText } from "lucide-react";
import { toast } from "sonner";
import { clienteFont } from "./clienteApi";

// Gate privacy mostrato subito dopo il PIN e prima del portale: informativa + consensi (obbligatori per accedere)
export function ConsensoGate({ src, onDone }) {
  const [info, setInfo] = useState(null);
  const [err, setErr] = useState(false);
  const [servizio, setServizio] = useState(false);
  const [statistico, setStatistico] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => { src.consensoStato().then(setInfo).catch(() => setErr(true)); }, [src]);

  const salva = async () => {
    setBusy(true);
    try { await src.consensoSalva({ informativa: servizio, statistico }); onDone(); }
    catch (e) { toast.error(e.response?.data?.detail || "Non riesco a salvare il consenso, riprova"); setBusy(false); }
  };

  return (
    <div className="flex min-h-screen items-start justify-center bg-gradient-to-b from-sky-50 to-white p-4 sm:items-center" style={{ fontFamily: clienteFont() }} data-testid="cliente-consenso-gate">
      <div className="my-6 w-full max-w-lg rounded-3xl bg-white p-6 shadow-xl ring-1 ring-slate-100">
        <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-sky-100"><ShieldCheck className="h-6 w-6 text-sky-600" /></span>
        <h1 className="mt-3 text-center text-xl font-extrabold text-slate-800">Privacy e consensi</h1>
        <p className="mt-1 text-center text-sm text-slate-500">Prima di entrare, leggi l'informativa e dai i consensi necessari.</p>

        {err && !info ? (
          <p className="mt-6 text-center text-sm text-slate-600" data-testid="cliente-consenso-errore">Non riesco a caricare l'informativa. Riprova più tardi.</p>
        ) : !info ? (
          <div className="flex justify-center py-12"><Loader2 className="h-7 w-7 animate-spin text-sky-500" /></div>
        ) : (
          <>
            <div className="mt-5 max-h-64 overflow-y-auto rounded-2xl bg-slate-50 p-4 text-[13px] leading-relaxed text-slate-700 ring-1 ring-slate-100 [&_h2]:mb-1 [&_h2]:text-base [&_h2]:font-extrabold [&_h2]:text-slate-800 [&_h3]:mt-3 [&_h3]:font-bold [&_h3]:text-slate-800 [&_ul]:mt-1 [&_ul]:list-disc [&_ul]:pl-5 [&_p]:mt-1 [&_.nota]:mt-3 [&_.nota]:text-[11px] [&_.nota]:text-slate-400"
              data-testid="cliente-consenso-informativa" dangerouslySetInnerHTML={{ __html: info.informativa_html }} />

            <label className="mt-4 flex cursor-pointer items-start gap-3 rounded-2xl bg-slate-50 p-3 ring-1 ring-slate-100">
              <input type="checkbox" checked={servizio} onChange={(e) => setServizio(e.target.checked)} data-testid="cliente-consenso-servizio" className="mt-0.5 h-5 w-5 flex-shrink-0 accent-sky-600" />
              <span className="text-[13px] text-slate-700">{info.servizio_testo}</span>
            </label>
            <label className="mt-3 flex cursor-pointer items-start gap-3 rounded-2xl bg-slate-50 p-3 ring-1 ring-slate-100">
              <input type="checkbox" checked={statistico} onChange={(e) => setStatistico(e.target.checked)} data-testid="cliente-consenso-statistico" className="mt-0.5 h-5 w-5 flex-shrink-0 accent-sky-600" />
              <span className="text-[13px] text-slate-700">{info.statistica_testo}</span>
            </label>

            <button type="button" onClick={salva} disabled={!servizio || busy} data-testid="cliente-consenso-submit"
              className="mt-5 flex h-12 w-full items-center justify-center gap-2 rounded-2xl bg-sky-500 font-bold text-white transition-colors hover:bg-sky-600 disabled:opacity-40">
              {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : <FileText className="h-5 w-5" />}Accetto ed entro</button>
            <p className="mt-3 text-center text-[11px] text-slate-400">Puoi revocare il consenso in qualsiasi momento scrivendo via PEC a torrisolare@pec.it.</p>
          </>
        )}
      </div>
    </div>
  );
}
